import { cn } from '@/lib/utils'

import {
  BLOCK_COLUMNS,
  BLOCK_GAP,
  BLOCK_HEIGHT,
} from '../../components/blocks/shared/constants'
import { Skeleton } from '../../components/ui/skeleton'

export type PageLoadingProps = {
  blocks?: { w: number; h: number; x: number; y: number }[]
  hideHeader?: boolean
  maxWidth?: number
}

export const DEFAULT_BLOCKS = [
  { w: 4, h: 4, x: 1, y: 1 },
  { w: 2, h: 8, x: 1, y: 5 },
  { w: 2, h: 4, x: 3, y: 5 },
  { w: 2, h: 4, x: 3, y: 9 },
  { w: 2, h: 4, x: 1, y: 13 },
  { w: 2, h: 4, x: 3, y: 13 },
]

export const PageLoading = ({
  blocks = DEFAULT_BLOCKS,
  hideHeader,
  maxWidth = 550,
}: PageLoadingProps) => {
  return (
    <div className="relative flex h-full flex-col">
      <div className="relative z-1 w-full flex-1 font-page-body font-page-body-weight text-page-text">
        <div
          className={cn({
            'pt-12': !hideHeader,
          })}
        >
          {!hideHeader && (
            <div className="z-30 mx-auto w-full" style={{ maxWidth }}>
              <div className="mx-auto mb-4 flex size-[80px] items-center justify-center overflow-hidden rounded-full">
                <Skeleton className="size-[80px] rounded-full" />
              </div>

              <div className="flex w-full flex-col">
                <div className="mx-auto mb-4">
                  <Skeleton className="h-9 w-44" />
                </div>

                <div className="mx-auto mb-12">
                  <Skeleton className="h-4 w-60" />
                </div>
              </div>
            </div>
          )}

          <div className="relative">
            <div className="flex justify-center">
              <div className="w-full" style={{ maxWidth }}>
                <div className="px-4">
                  <div
                    className="relative grid"
                    style={{
                      gridTemplateColumns: `repeat(${BLOCK_COLUMNS}, minmax(0, 1fr))`,
                      gap: BLOCK_GAP,
                      gridAutoRows: BLOCK_HEIGHT,
                    }}
                  >
                    {blocks.map(({ x, y, w, h }, index) => (
                      <div
                        key={index}
                        style={{
                          gridColumn: `${x} / span ${w}`,
                          gridRow: `${y} / span ${h}`,
                        }}
                        className="relative"
                      >
                        <Skeleton className="size-full rounded-[32px]" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
